import { type InfiniteData, type QueryKey, useInfiniteQuery, type UseInfiniteQueryOptions } from "@tanstack/react-query";
import type { HTTPResponse, ProblemResponse } from "@/lib/http/useHTTP";
import type { PaginatedResponseModel } from "@/lib/http/PaginatedResponseModel";
import type { PaginatedInfiniteQueryResult } from "@/lib/common/PaginatedInfiniteQueryResult";

export type UseHTTPQueryWithCursorOptions<T> = Omit<UseInfiniteQueryOptions<PaginatedResponseModel<T>, ProblemResponse, InfiniteData<PaginatedResponseModel<T>>, QueryKey, number>, "getNextPageParam" | "getPreviousPageParam" | "initialPageParam" | "queryFn"> & {
	queryFn: (context: { pageParam: number }) => Promise<HTTPResponse<PaginatedResponseModel<T>>>;
};

export const useHTTPQueryWithCursor = <T>(options: UseHTTPQueryWithCursorOptions<T>): PaginatedInfiniteQueryResult<T> => useInfiniteQuery({
	...options,
	queryFn: async (context) => {
		const response = await options.queryFn(context);
		return response.body;
	},
	initialPageParam: 0,
	getNextPageParam: x => x.nextCursor,
	getPreviousPageParam: () => null
});
